import React, { useEffect, useState } from 'react';
import OnboardInput from '../../component/base/onboard-input/OnboardInput';
import OnboardPassword from '../../component/base/onboard-password/OnboardPassword';
import OnboardSelect from '../../component/base/onboard-select-component/OnboardSelect';
import OnboardButton from '../../component/base/onboard-button-component/OnboardButton';
import HeaderComponent from '../../component/base/header-component/HeaderComponent';
import FooterComponent from '../../component/base/footer-component/FooterComponent';
import { userRegisterModel, validation } from '../../model/UserRegisterModel';
import { genderOption } from '../../lookup/GenderLookup';
import MobileNumberComponent from '../../component/base/mobile-number-component/MobileNumberComponent';
import CompletedComponent from '../../component/base/completed-component/CompletedComponent';
import OnboardCheckboxAgreement
  from '../../component/base/onboard-checkbox-agreement-component/OnboardCheckboxAgreement';
import OnboardDialog from '../../component/base/onboard-dialog-component/OnboardDialog';
import OnboardDate from '../../component/base/onboard-date-component/OnboardDate';
import {
  getAreaCodeLookup,
  getMilesAndSmilesRegisterRightsGDPRLink,
  getMilesAndSmilesRegisterRightsGDPRLink2,
  getMilesAndSmilesRegisterRightsMilesLink,
  getMilesAndSmilesRegisterRightsTurkishAirlinesLink
} from '../../util/LanguageContentManager';
import { useSetRecoilState } from 'recoil';
import { informationAtom } from '../../store/InformationStore';
import { setSimulationNumber } from '../../util/SimulationManager';

const MilesAndSmilesRegisterPage = (props) => {
    const setInformation = useSetRecoilState(informationAtom);
    const {t, i18n, navigate, location, setLoading, user, setUser} = props.props;
    const simulationNumber = setSimulationNumber();

    const [error, setError] = useState(null);
    const [successVisible, setSuccessVisible] = useState(false);
    const [visibleIdentityCardNo, setVisibleIdentityCardNo] = useState(false);
    const [regUser, setRegUser] = useState(userRegisterModel);
    const [errorDialog, setErrorDialog] = useState({title: "", content: "", visible: false});
    const [msNumber, setMsNumber] = useState(null);
    const [regEncrypt, setRegEncrypt] = useState(false);
    const [editDisable, setEditDisable] = useState({
        name: false,
        surname: false,
        gender: false,
        nationality: false,
        birthdate: false
    });

    useEffect(() => {
        setInformation(prev => ({
            ...prev,
            type: "register_miles_smiles"
        }));
        simulationNumber(6, 1);
    }, []);

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    const register = () => {
        if (!control().error) {
            registerSend();
        }
        window.scrollTo({top: 0, behavior: "smooth"});
    }

    const control = () => {
        if (!visibleIdentityCardNo) regUser.identityCardNo = null;
        const valid = validation(regUser, t);
        setError(valid);
        return valid;
    }

    const registerSend = () => {
        setLoading(true);
        setTimeout(()=>{
          setLoading(false);
          handleErrorMessage("SERVER", "");
        },3000);
    }

    const handleErrorMessage = (message, code) => {
        const valid = validation(regUser, t);
        if (code === "APIGW-ERR-MS040100FV_10" || message.toLowerCase().includes("tckn") ||
            message.toLowerCase().includes("identity card number") || message.toLowerCase().includes("mernis customer not found")) {
            setError({...valid, identityCardNo: message})
        } else if (code === "APIGW-ERR-MS040100FV_15" || message.toLowerCase().includes("birth date") || message.toLowerCase().includes("yaşından küçüklere")) {
            setError({...valid, birthdate: message})
        } else if (code === "APIGW-ERR-MS040100FV_3" || message.toLowerCase().includes("soyisim bilgisi") ||
            code === "APIGW-ERR-MS040100FV_4" || message.toLowerCase().includes(". surname")) {
            setError({...valid, surname: message})
        } else if (code === "APIGW-ERR-MS040100FV_1" || message.toLowerCase().includes("i̇sim bilgisi") ||
            code === "APIGW-ERR-MS040100FV_2" || message.toLowerCase().includes(". name")) {
            setError({...valid, name: message})
        } else if (code === "APIGW-ERR-MS040100FV_5" || code === "APIGW-ERR-MS040100FV_14" || message.toLowerCase().includes("format of mail") ||
            message.toLowerCase().includes("posta bilgisinin") || message.includes(". emailAddress") || code === "APIGW-ERR-MS-012") {
            setError({...valid, email: message})
        } else if (code === "APIGW-ERR-MS040100FV_25" || code === "APIGW-ERR-MS040100FV_9" || code.includes("APIGW-ERR-MS040100FV_13") || message.toLowerCase().includes("format of mobile phone") || message.toLowerCase().includes("mobile number") ||
            message.toLowerCase().includes("mobil telefon numara") || message.toLowerCase().includes(". phone") || message.toLowerCase().includes("mobile phone")) {
            setError({...valid, mobileNumber: message})
        } else if (message.toLowerCase().includes("duplicate membership") || message.toLowerCase().includes("sistemimizde kayıtlıdır")) {
            setErrorDialog({...error, visible: true, content: message})
        } else if (code.includes("APIGW-ERR-MS040100MRN05")) {
            setErrorDialog({...error, visible: true, content: message})
        } else if (code.includes("APIGW-ERR-MS040100PIN_")) {
            setErrorDialog({...error, visible: true, content: message})
        } else {
            setErrorDialog({...error, visible: true, content: t('error.an_unknown_error')})
        }
    }

    const rightsMilesLink = () => {
        return getMilesAndSmilesRegisterRightsMilesLink(i18n);
    }

    const rightsMiles = {
        label: t('register.rights_miles_and_smiles'),
        link: [{
            text: t('register.rights_miles_and_smiles_link'),
            link: rightsMilesLink()
        }]
    }

    const rightsTurkishAirlinesLink = () => {
        return getMilesAndSmilesRegisterRightsTurkishAirlinesLink(i18n);
    }

    const rightsTurkishAirlines = {
        label: t('register.rights_turkish_airlines'),
        link: [{
            text: t('register.rights_turkish_airlines_link'),
            link: rightsTurkishAirlinesLink()
        }]
    }

    const rightsGDPRLink = () => {
        return getMilesAndSmilesRegisterRightsGDPRLink(i18n);
    }

    const rightsGDPRLink2 = () => {
        return getMilesAndSmilesRegisterRightsGDPRLink2(i18n);
    }

    const rightsGDPR = {
        label: t('register.rights_gdpr'),
        link: [{
            text: t('register.rights_gdpr_link'),
            link: rightsGDPRLink()
        }, {
            text: t('register.rights_gdpr_link_2'),
            link: rightsGDPRLink2()
        }]
    }

    const handleNationalitySelect = (e) => {
        if (e.value !== 'TR') setVisibleIdentityCardNo(false);
        else setVisibleIdentityCardNo(true);
        setRegUser({...regUser, nationality: e});
    }

    const handleReturnHome = () => {
        simulationNumber(7, 1);
        if (location.state === null) navigate("/login")
        else if (location.state === "login") navigate("/login")
        else navigate(-1)
    }

    const getNationalityOptions = () => {
        let list = []
        getAreaCodeLookup(i18n).forEach(t => {
            if (t.code !== "—")
                list.push({label: t.optionLabel, value: t.code});
        })
        return list;
    }

    return (
        <div>
            <HeaderComponent title={t('register.title')} content={t('register.content')}/>

            <div className="content-root">

                <p className="content-title">{t('register.member_info')}</p>

                <div className="grid-components">

                    <div className="flx">

                        <OnboardInput placeholder={t('register.name')} value={regUser.name}
                                      onChange={(e) => setRegUser({...regUser, name: e})}
                                      disabled={editDisable.name} error={error?.name} upperAndEng/>

                        <OnboardInput placeholder={t('register.surname')} value={regUser.surname}
                                      onChange={(e) => setRegUser({...regUser, surname: e})}
                                      disabled={editDisable.surname} error={error?.surname} upperAndEng/>
                    </div>

                    <div className="flx">

                        <OnboardSelect placeholder={t('register.gender')} options={genderOption(t)}
                                       value={regUser.gender} error={error?.gender} disabled={editDisable.gender}
                                       onChange={(e) => setRegUser({...regUser, gender: e})}/>

                        <OnboardSelect placeholder={t('register.nationality')} options={getNationalityOptions()}
                                       value={regUser.nationality} error={error?.nationality}
                                       disabled={editDisable.nationality}
                                       onChange={(e) => handleNationalitySelect(e)}/>

                    </div>

                    {visibleIdentityCardNo &&
                        <OnboardInput placeholder={t('register.identity_card_no')} value={regUser.identityCardNo}
                                      mask={{mask: "9{1,11}", greedy: true}}
                                      onChange={(e) => setRegUser({...regUser, identityCardNo: e})}
                                      error={error?.identityCardNo}/>
                    }

                    <OnboardDate placeholder={t('register.birth_date')} value={regUser.birthdate}
                                 onChange={(e) => setRegUser({...regUser, birthdate: e})}
                                 error={error?.birthdate} disabled={editDisable.birthdate}/>

                </div>

                <p className="content-title">{t('register.communication_info')}</p>

                <div className="grid-components">

                    <MobileNumberComponent onChangeNumber={(e) => setRegUser({...regUser, mobileNumber: e})}
                                           onChangeAreaCode={(e) => setRegUser({...regUser, areaCode: e})}
                                           errorAreaCode={error?.areaCode} errorNumber={error?.mobileNumber}
                    />

                    <OnboardInput placeholder={t('register.e_mail')} value={regUser.email}
                                  onChange={(e) => setRegUser({...regUser, email: e})} error={error?.email}/>
                </div>

                <p className="content-title">{t('register.your_password')}</p>

                <div className="grid-components">

                    <OnboardPassword placeholder={t('register.password')} showHint
                                     onChange={(e) => setRegUser({...regUser, passcode: e})}
                                     value={regUser.passcode} error={error?.passcode}/>

                    <OnboardPassword placeholder={t('register.password_repeat')}
                                     onChange={(e) => setRegUser({...regUser, repeatPasscode: e})}
                                     value={regUser.repeatPasscode} error={error?.repeatPasscode}/>

                    <div className="h-8"/>

                    <OnboardCheckboxAgreement
                        value={regUser.rightsMiles}
                        error={error?.rightsMiles}
                        onChange={(e) => setRegUser({...regUser, rightsMiles: e})}
                        label={rightsMiles}/>

                    <OnboardCheckboxAgreement
                        value={regUser.rightsTurkishAirlines}
                        error={error?.rightsTurkishAirlines}
                        onChange={(e) => setRegUser({...regUser, rightsTurkishAirlines: e})}
                        label={rightsTurkishAirlines}/>

                    <OnboardCheckboxAgreement
                        value={regUser.rightsGDPR}
                        error={error?.rightsGDPR}
                        onChange={(e) => setRegUser({...regUser, rightsGDPR: e})}
                        label={rightsGDPR}/>

                </div>

                <OnboardButton label={t('register.register_btn')} onClick={() => register()}/>

                <p onClick={() => handleReturnHome()} className="cancel">{t('return_home')}</p>

            </div>

            <FooterComponent/>

            <OnboardDialog error
                           visible={errorDialog.visible}
                           title={errorDialog.title}
                           content={errorDialog.content}
                           cancelShow cancelText={t('home.close')}
                           onClickCancel={() => setErrorDialog({...errorDialog, visible: false})}
            />

            <CompletedComponent
                visible={successVisible}
                title={t('register.miles_and_smiles_member_id')}
                description={t('register.success_description')}
                confirmText={t('login.tabs.milesandsmiles')}
                copyText={msNumber} confirm={() => navigate("/login", {state: 'msregister'})}/>
        </div>
    );
};

export default MilesAndSmilesRegisterPage;

